// extracted by mini-css-extract-plugin
module.exports = {"vipCard":"VipCard_vipCard__1gLVH","cardLogo":"VipCard_cardLogo__3RRHF"};